import {mapGetters, mapMutations, mapActions} from 'vuex'

export default {
  name: 'popupLogin',
  //---components
  //---data
  data () {
    return {
      statusMessageCollection: [
        'Authorization...',
        'Authorization failed. Try later',
        'Access required',
        'Require Authorization',
        'Login successful',
        'Access denied'
      ]
    }
  },
  //---hooks
  computed: {
    ...mapGetters({
      isAuthLoading: 'AUTH/isAuthLoading',
      user: 'AUTH/user',
      isHasPTFToken: 'AUTH/isHasPTFToken',
      isAuthError: 'AUTH/isAuthError',
      authSaveRoutes: 'AUTH/authSaveRoutes',
      authStatus: 'AUTH/authStatus',

      popupStore: 'APP/popupStore',
      isLoaderActive: 'APP/isLoaderActive',
    }),
    isRequireEnablePtfSalesView: function () {
      return this.authSaveRoutes && this.authSaveRoutes.to.matched.some(record => record.meta.requiresAuth)
    },
    getCurrentStatus: function () {
      let statusId = 0
        if (this.isAuthError) {
          statusId = 1
        } else {
          if (!this.isHasPTFToken) {
            statusId = 2;
          } else {
            if (!this.user) {
              statusId = 3;
            } else {
              if (this.isRequireEnablePtfSalesView) {
                if (this.user.enablePtfSalesView) {
                  statusId = 4;
                } else {
                  statusId = 5;
                }
              } else {
                statusId = 4;
              }
            }
          }
        }
      return statusId
    }
  },
  //---methods
  methods: {
    ...mapMutations({
      loaderFlag: 'APP/APP_LOADER_FLAG_TOGGLE',
      popupClose: 'APP/APP_POPUP_CLOSE',
      setAuthError: 'AUTH/AUTH_ERROR_SET',
      setAuthRoutes: 'AUTH/AUTH_ROUTES_SET',
    }),
    ...mapActions({
      createNotifications: 'NOTIFICATIONS/NOTIFICATIONS_CREATE_REQUEST_SET',
      getLogin: 'AUTH/AUTH_LOGIN_REQUEST',
    }),
    closeLoginPopup() {
      this.popupClose('popupLogin');

      if (this.authSaveRoutes && this.authSaveRoutes.from) {
        this.$router.push({name: this.authSaveRoutes.from.name}).catch(err => {});
      } else {
        if (this.$route.matched.some(record => record.meta.requiresAuth)) {
          this.$router.push({name: 'home'});
        }
      }
      setTimeout(()=>{
        this.setAuthRoutes(null);
        this.setAuthError(false);
      },400);
    },

    getAccessFromPTF() {
      window.location.href = process.env.VUE_APP_PTF_SITE_URL + '/login';
    },

    login() {
      this.getLogin();
    },

    continueRoute() {
      this.popupClose('popupLogin');
      if (this.authSaveRoutes && this.authSaveRoutes.to) {
        this.$router.push({name: this.authSaveRoutes.to.name}).catch(err => {});
      } else {
        if (this.$route.matched.some(record => record.meta.requiresAuth)) {
          this.$router.push({name: 'home'}).catch(err => {});
        }
      }
      this.setAuthRoutes(null);
    },
  }
}